<template>
  <div class="full-height bg-white">
    <mescroll-vue
      ref="mescrollbtnlh"
      :down="down"
    >
      <van-swipe
        :autoplay="5000"
        :height="clientWidth"
      >
        <van-swipe-item
          v-for="(advertise, index_) in images"
          :key="index_"
        >
          <van-image
            lazy-load
            :src="advertise.pictureUrl"
            @click="goAdvertiseLink(advertise.advertiseLink)"
            :height="isH5()?clientWidth:clientWidth"
            class="full-width"
          />
        </van-swipe-item>
      </van-swipe>
      <div class="iconTheme">
        <van-row
          type="flex"
          align="center"
          class="menu text-center"
        >
          <van-col
            span="6"
            v-for="(item, index) in menuList"
            :key="index"
            :class="[item.openDiasble ? 'menu-disabled' : '']"
            class="menu-item"
            @click="to(item)"
            style="margin-bottom:7px"
          >
            <div style="height: 38px">
              <van-image
                lazy-load
                width="50"
                height="50"
                :src="item.img"
                class="full-width"
              />
            </div>
            <div class="font14 font-md logotext">
              {{ $t(item.title) }}
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="contain">
        <van-cell
          :border="false"
          v-if="showCcsqd"
        >
          <van-image
            class="full-width"
            height="72"
            lazy-load
            :src="application"
            @click="$router.push({ path: '/tripList' })"
          />
        </van-cell>
        <van-cell
          :border="false"
          v-else
        >
          <van-image
            class="full-width"
            height="72"
            lazy-load
            :src="approval"
            @click="$router.push({ path: '/approvalList' })"
          />
        </van-cell>
        <van-cell
          title="交易明细"
          @click="showFilter = true"
        >
          <span class="black">时间</span>
          <template #right-icon>
            <ld-icon
              icon-class="main-color"
              size="12"
              type="icondown2"
            />
          </template>
        </van-cell>
        <div
          v-for="item in orderList"
          :key="item.id"
          class="m-b-5"
          @click="toDetail(item)"
        >
          <van-cell
            title-class="full-width"
            v-show="item.isShow"
          >
            <template
              slot="title"
              class="full-width"
            >
              <!-- 机票  火车-->
              <div
                v-show="
                  item.orderType == 11001 ||
                    item.orderType == 11002 ||
                    item.orderType == 11003 ||
                    item.orderType == 11004 ||
                    item.orderType == 11005 ||
                    item.orderType == 11006 ||
                    item.orderType == 11009 ||
                    item.orderType == 11010 ||
                    item.orderType == 11011 ||
                    item.orderType == 11023
                "
              >
                <van-row
                  type="flex"
                  align="center"
                  justify="space-between"
                >
                  <van-col span="17">
                    <div class="-inline-wrap">
                      <div class="-block-wrap">
                        <div class="-block">
                          <!-- <img
                          class="icon vertical-bottom"
                          :src="item.orderType|icon"
                        > -->
                          <ld-icon
                            style="vertical-align: bottom"
                            size="22"
                            :color="item.orderType | color"
                            :type="item.orderType | icon"
                          />
                          <span class="font16 font-bold">
                            <span v-if="item.orderType == 11023">
                              {{ item.xcdd }}</span>
                            <span v-else> {{ item.voyageZh }}</span>
                          </span>
                          &nbsp;
                          <van-tag
                            class="-icon"
                            v-if="
                              item.orderType == 11002 ||
                                item.orderType == 11005 ||
                                item.orderType == 11010 ||
                                item.orderType == 11020
                            "
                            type="success"
                          >
                            {{ $t("H117", "退") }}
                          </van-tag>
                          <van-tag
                            class="-icon"
                            v-if="
                              item.orderType == 11003 ||
                                item.orderType == 11006 ||
                                item.orderType == 11011
                            "
                            type="danger"
                          >
                            改
                          </van-tag>
                          <van-tag
                            v-show="
                              item.productType &&
                                item.productType != 1 &&
                                item.productType != 6
                            "
                            plain
                            :color="item.productType | productTypeColor"
                          >
                            {{ item.productType | productType }}
                          </van-tag>
                          &nbsp;
                          <van-tag
                            type="danger"
                            plain
                            v-show="item.isyw == 1"
                          >
                            {{ $t("F620", "延误/取消") }}
                          </van-tag>
                        </div>
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    span="7"
                    class="text-right"
                  >
                    {{ item.orderStatusRemark }}
                  </van-col>
                </van-row>
                <van-row>
                  <van-col
                    span="17"
                    class="van-ellipsis"
                  >
                    {{ item.departTime }} | {{ item.flightNo }} |
                    {{ item.cabinName }}
                  </van-col>
                  <van-col
                    span="7"
                    class="red text-right"
                  >
                    <span class="font12">&yen; </span>
                    <big>
                      {{
                        (item.subtotal - 0
                          ? item.subtotal - 0
                          : item.subtotal) +
                          (item.subtotal - 0 ? item.bxPrice || 0 : "")
                      }}
                    </big>
                  </van-col>
                </van-row>
              </div>
              <!-- 机票  火车-->

              <!-- 酒店 -->
              <div v-if="item.orderType == 11007 || item.orderType == 11008">
                <van-row
                  type="flex"
                  align="center"
                  justify="space-between"
                >
                  <van-col span="18">
                    <div class="-inline-wrap">
                      <div class="-block-wrap">
                        <div class="-block">
                          <!-- <img
                          class="icon vertical-bottom"
                          :src="item.orderType|icon"
                        > -->
                          <ld-icon
                            style="vertical-align: bottom"
                            size="22"
                            :color="item.orderType | color"
                            :type="item.orderType | icon"
                          />
                          <span class="font16 font-bold">
                            <span> {{ item.voyageZh }}</span>
                          </span>
                          &nbsp;
                          <van-tag
                            class="-icon"
                            v-if="item.orderType == 11008"
                            type="success"
                          >
                            {{ $t("H117", "退") }}
                          </van-tag>
                        </div>
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    span="6"
                    class="text-right"
                  >
                    {{ item.orderStatusRemark }}
                  </van-col>
                </van-row>
                <van-row>
                  <van-col
                    span="17"
                    class="van-ellipsis"
                  >
                    <div>
                      {{
                        item.departTime.substring(5, item.departTime.length)
                      }}
                      {{ $t("H041", "至") }}
                      {{
                        item.nDepartTime.substring(
                          5,
                          item.nDepartTime.length
                        )
                      }}
                      | {{ item.nights }}
                      {{ $t("H008", "晚") }}
                      <span v-if="item.productImage == 2">
                        |
                        {{
                          item.voyageType == "1"
                            ? item.productType == "1"
                              ? "到店付-担保"
                              : "到店付"
                            : $t("H030", "预付")
                        }}</span>
                    </div>
                    {{ item.flightNo }} | {{ item.rooms }}
                    {{ $t("E205", "间") }}
                  </van-col>
                  <van-col
                    span="7"
                    class="red text-right"
                  >
                    <span class="font12">&yen; </span><big> {{ item.subtotal }}</big>
                  </van-col>
                </van-row>
              </div>
              <!-- 酒店 -->

              <!-- 用车 -->
              <div v-show="item.orderType == 11018">
                <van-row
                  type="flex"
                  align="center"
                  justify="space-between"
                >
                  <van-col span="18">
                    <div class="-inline-wrap">
                      <div class="-block-wrap">
                        <div class="-block">
                          <!-- <img
                          class="icon vertical-bottom"
                          :src="item.orderType|icon"
                        > -->
                          <ld-icon
                            style="vertical-align: bottom"
                            size="22"
                            :color="item.orderType | color"
                            :type="item.orderType | icon"
                          />
                          <span class="font16 font-bold">
                            {{ item.voyageZh
                            }}<span v-show="item.productType">-{{
                              item.productType | carproductType
                            }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    span="6"
                    class="text-right"
                  >
                    {{ item.orderStatusRemark }}
                  </van-col>
                </van-row>
                <van-row>
                  <van-col
                    span="17"
                    class="van-ellipsis"
                  >
                    {{ item.departTime }} | {{ item.cabinName }}
                  </van-col>
                  <van-col
                    span="7"
                    class="red text-right"
                  >
                    <span class="font12">&yen; </span><big> {{ item.subtotal }}</big>
                  </van-col>
                </van-row>
                <van-row
                  type="flex"
                  align="center"
                >
                  <van-col span="2">
                    <div>
                      <img
                        src="~Assets/images/car/start.png"
                        alt="上车地点"
                        width="20"
                        class="vertical-middle"
                      >
                    </div>
                  </van-col>
                  <van-col span="17">
                    <div>
                      {{ item.scdd ? item.scdd.split("|")[0] : "" }}
                    </div>
                  </van-col>
                </van-row>
                <van-row
                  type="flex"
                  align="center"
                >
                  <van-col span="2">
                    <div>
                      <img
                        src="~Assets/images/car/end.png"
                        alt="下车地点"
                        width="21"
                        class="vertical-middle"
                      >
                    </div>
                  </van-col>
                  <van-col span="17">
                    <div>
                      {{ item.xcdd ? item.xcdd.split("|")[0] : "" }}
                    </div>
                  </van-col>
                </van-row>
              </div>
              <!-- 用车 -->

              <!-- 机场服务 -->
              <div
                v-if="
                  item.orderType == 11028 ||
                    item.orderType == 11029 ||
                    item.orderType == 11030 ||
                    item.orderType == 11031
                "
              >
                <van-row
                  type="flex"
                  align="center"
                  justify="space-between"
                >
                  <van-col span="18">
                    <div class="-inline-wrap">
                      <div class="-block-wrap">
                        <div class="-block">
                          <!-- <img
                          class="icon vertical-bottom"
                          :src="item.orderType|icon"
                        > -->
                          <ld-icon
                            style="vertical-align: bottom"
                            size="22"
                            :color="item.orderType | color"
                            :type="item.orderType | icon"
                          />
                          <span class="font16 font-bold">
                            {{ item.orderType | orderType }} -
                            {{ item.voyageZh }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    span="6"
                    class="text-right"
                  >
                    {{ item.orderStatusRemark }}
                  </van-col>
                </van-row>
                <van-row>
                  <van-col
                    span="17"
                    class="van-ellipsis"
                  >
                    <div v-show="item.orderType == 11028">
                      {{ item.cabinName }} | {{ item.personNum }}人次
                    </div>
                    <div v-show="item.orderType == 11029">
                      {{ item.nCabinName | setOutModel }} |
                      {{ item.nFlightNo }}航站楼 | {{ item.personNum }}人次
                    </div>
                    <div v-show="item.orderType == 11030">
                      {{ item.departTime }} | {{ item.flightNo }} |
                      {{ item.personNum }}人次
                    </div>
                    <div v-show="item.orderType == 11031">
                      {{ item.departTime }} | {{ item.flightNo }} |
                      {{ item.personNum }}人次
                    </div>
                  </van-col>
                  <van-col
                    span="7"
                    class="red text-right"
                  >
                    <span class="font12">&yen; </span><big> {{ item.subtotal || 0 }}</big>
                  </van-col>
                </van-row>
              </div>
              <!-- 机场服务 -->

              <div>
                <span class="line-clamp">
                  <van-tag
                    v-if="item.tripType == 2"
                    plain
                    color="#5E68A0"
                  >
                    私
                  </van-tag>
                  {{ item.psgName }}
                </span>
              </div>
            </template>
            <!--  -->
            <template slot="label">
              <van-row
                gutter="8"
                type="flex"
                justify="end"
              >
                <van-col
                  span="6"
                  v-if="item.isShowCancelApproval==1"
                >
                  <ld-button
                    main
                    size="sm"
                    @click.stop="revertApproval(item)"
                  >
                    {{ $t('B065','撤回') }}
                  </ld-button>
                </van-col>
                <van-col
                  span="6"
                  v-if="item.isShowApproval==1"
                >
                  <ld-button
                    main
                    size="sm"
                    @click.stop="sendApproval(item)"
                  >
                    {{ $t('B028','送审') }}
                  </ld-button>
                </van-col>
              </van-row>
            </template>
            <!--  -->
          </van-cell>
        </div>
        <ld-no-more v-show="orderList.length == 0" />
      </div>
    </mescroll-vue>
    <!-- 筛选 -->
    <order-panel
      ref="filter"
      :visibility.sync="showFilter"
      :filter.sync="params"
      @selected="filterEnter"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  Tabbar,
  TabbarItem,
  Popup,
  Grid,
  GridItem,
  Icon,
  NoticeBar,
  Swipe,
  SwipeItem,
  Cell,
  Image as VanImage,
  Tag,
} from 'vant'
import { update } from 'CommonUtils/updateApp.js'
import { isH5, isAndroid, isIOS } from 'CommonUtils/plus.js'
import ldButton from 'Common/ldButton'
import ldStatusbar from 'Common/ldStatusbar'

import { formatDate, getRelativeDate } from 'Utils/dateUtil'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { localget } from 'Utils/storage.js'
import orderPanel from 'Views/Home/allorder/components/orderPanel'
import ldNoMore from 'Common/ldNoMore'
import Bussiness from 'Utils/business'
import amap from 'Utils/amap'
import { gcj02tobd09 } from 'Utils/convertGps.js'

import menu_tk from 'Components/Dynamic/btlh/images/menu/menu_tk_new.png'
import menu_ht from 'Components/Dynamic/btlh/images/menu/menu_ht_new.png'
import menu_tr from 'Components/Dynamic/btlh/images/menu/menu_tr_new.png'
import menu_car from 'Components/Dynamic/btlh/images/menu/menu_car_new.png'
import menu_visa from 'Components/Dynamic/btlh/images/menu/menu_visa_new.png'

// import menu_business from 'Components/Dynamic/btlh/images/menu/menu_business.png'
import menu_business1 from 'Components/Dynamic/btlh/images/menu/menu_business1.png'
// import menu_office from 'Components/Dynamic/btlh/images/menu/menu_office.png'
import menu_office1 from 'Components/Dynamic/btlh/images/menu/menu_office1.png'
// import menu_drinks from 'Components/Dynamic/btlh/images/menu/menu_drinks.png'
import menu_drinks1 from 'Components/Dynamic/btlh/images/menu/menu_drinks1.png'
// import menu_food from 'Components/Dynamic/btlh/images/menu/menu_food.png'
import menu_food1 from 'Components/Dynamic/btlh/images/menu/menu_food1.png'
// import menu_gift from 'Components/Dynamic/btlh/images/menu/menu_gift.png'
import menu_gift1 from 'Components/Dynamic/btlh/images/menu/menu_gift1.png'
// import menu_soft from 'Components/Dynamic/btlh/images/menu/menu_soft.png'
import menu_soft1 from 'Components/Dynamic/btlh/images/menu/menu_soft1.png'
// import menu_need from 'Components/Dynamic/btlh/images/menu/menu_need.png'
import menu_need1 from 'Components/Dynamic/btlh/images/menu/menu_need1.png'

import banner1 from 'Components/Dynamic/btlh/images/banner/banner1.png'
import banner2 from 'Components/Dynamic/btlh/images/banner/banner2.png'
import banner3 from 'Components/Dynamic/btlh/images/banner/banner3.png'
import banner4 from 'Components/Dynamic/btlh/images/banner/banner4.png'
import banner5 from 'Components/Dynamic/btlh/images/banner/banner5.jpg'
import banner6 from 'Components/Dynamic/btlh/images/banner/banner6.jpg'

import application from 'Components/Dynamic/btlh/images/banner-application.png'
import approval from 'Components/Dynamic/btlh/images/banner-approval.png'
import orderMixin from '@/business/views/Home/allorder/components/orderMixin'
import homeMixin from '../default/homeMixin'

export default {
  name: 'Home',
  mixins: [orderMixin, homeMixin],
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    [Tag.name]: Tag,
    MescrollVue,
    orderPanel,
    ldNoMore,
    ldButton,
    ldStatusbar,
  },
  data () {
    return {
      application,
      approval,
      down: { use: false },
      images: [
        {pictureUrl:banner6,advertiseLink:'#'},
        {pictureUrl:banner5,advertiseLink:'#'},
        {pictureUrl:banner4,advertiseLink:'#'},
        {pictureUrl:banner3,advertiseLink:'#'},
        {pictureUrl:banner2,advertiseLink:'#'},
        {pictureUrl:banner1,advertiseLink:'#'},
      ],
      menuList: [
        {
          link: '/tk/tkQuery',
          title: 'A008', //机票
          img: menu_tk,
          PRO_TYPE: 10901,
        },
        {
          link: '/ht/htQuery',
          title: 'A009', //酒店
          img: menu_ht,
          PRO_TYPE: 10903,
        },
        {
          link: '/car/carQuery',
          title: 'A011', //用车
          img: menu_car,
          PRO_TYPE: 10906,
        },
        {
          link: '/tr/trQuery',
          title: '火车', //火车票
          img: menu_tr,
          PRO_TYPE: 10904,
        },
        {
          link: '/visa',
          title: 'A012', //签证
          img: menu_visa,
          PRO_TYPE: 10913,
        },
      ],
      orderList: [],
      showCcsqd: false,
      showFilter: false,
      params: {
        dateStart: getRelativeDate(-30),
        dateEnd: getRelativeDate(0),
        dateType: '1', // 1 预订日期,2 是出发/入住日期
        findScope: '1', // 1是个人订单,2是全部订单 ,
        findType: '1', // 1全部订单 2待支付 3待出行 4退改 5指定的业务订单（productType必须传值）
        productType: '', //产品类型
        tripType: '',
        pageNum: 1,
        count: 50,
      },
      weather: {
        reportTime: '',
      },
      clientWidth: document.body.clientWidth * 0.9
    }
  },
  async created () {
    this.getOrderList()
    await this.getAuthorizationPnos()
    this.genMenu([...this.menuList])
    this.getPullData()
    this.getLoginNotice(0) //获取登录公告
    this.getBadgeCount()
    this.checkOpenId()
  },
  mounted () {
    update() //app 更新
    if (this.userInfo && this.userInfo.vipCorp) {
      if (this.userInfo.vipCorp.bookStyle == 1) {
        this.showCcsqd = false
      } else {
        this.showCcsqd = true
      }
    } else {
      let userInfo = localget('userInfo')
      if (userInfo) {
        this.$store.commit('SET_USERINFO', userInfo)
        //如果是单订模式 删除申请单的入口
        if (userInfo.vipCorp && userInfo.vipCorp.bookStyle == 1) {
          this.showCcsqd = false
        } else {
          this.showCcsqd = true
        }
      }
    }
    var self = this
    setTimeout(() => {
      self.appGps()
    }, 1000)
  },
  methods: {
    isH5,
    //获取交易明细
    getOrderList () {
      this.$api['common/allOrderList'](this.params)
        .then((res) => {
          var cache = res.data || {}
          var list = cache.list || []
          list.forEach((el) => {
            if (el.orderStatus == 7) {
              el.isShow = false
            } else {
              el.isShow = true
            }
          })
          this.orderList = list
        })
        .catch(() => { })
    },
    getPullData () {
      let data = {
        requestFrom:2
      }
      this.$api['common/pullData'](data).then(res=>{
        if(res.data){
          const {data} = res
          let advertiseList = []
          data.forEach(element=>{
            let advertise = {
              pictureUrl:element.pictureUrl,
              advertiseLink:element.advertiseLink
            }
            advertiseList.push(advertise)
          })
          this.images = advertiseList
        }
      })
    },
    goAdvertiseLink(path){
      if(path){
        location.href = path
      }
    },
    //排序
    orderBy () {
      this.getOrderList()
    },
    filterEnter (params) {
      Object.assign(this.params, params)
      this.getOrderList()
    },
    to (item) {
      if (item.openDiasble) {
        this.$toast('暂未开放，敬请期待！')
      } else {
        this.$router.push({ path: item.link })
      }
    },
    toDetail (item) {
      Bussiness.toOrderDetail(item)
    },
    sendApproval (detail) { // 送审
      Bussiness.ApprovalSend(detail)
    },
    async revertApproval (detail) { // 撤回送审
      await Bussiness.ApprovalRevert(detail)
      this.getOrderList()
    },
    appGps () {
      var self = this
      amap.appGps().then((point) => {
        if (point) {
          if (isAndroid() || isIOS()) {
            //app定位成功回调
            if (point.address) {
              self.getWeather(point.address.city)
            }
          } else {
            self.geocoder(point)
          }
        }
      })
    },
    getWeather (cityName) {
      var self = this
      amap.getWeather(cityName || '内蒙古').then(({ err, data }) => {
        if (err) {
          self.$toast(err)
        } else {
          self.weather = data || {}
          if (data.reportTime) {
            self.weather.reportTime = formatDate(data.reportTime).monDayWeek
          }
        }
      })
    },
    geocoder (point) {
      //根据经纬度 获取详细地址信息
      var self = this
      var arr = gcj02tobd09(point.lng, point.lat) //转为百度坐标
      var obj = {
        lon: arr[0], // 纬度
        lat: arr[1], // 经度
        coordsType: 'bd09ll',
      }
      amap.Geocoder(obj, function (res) {
        //根据经纬度获取城市id
        let cache = res.data || ''
        if (cache) {
          self.getWeather(cache.city)
        } else {
          // self.$toast('定位失败！')
        }
      })
    },
  },
  filters: {
    icon (val) {
      let obj = {
        11001: 'icondingdanlie-feiji', //icon_tk,
        11002: 'icondingdanlie-feiji', //icon_tk,
        11003: 'icondingdanlie-feiji', //icon_tk,
        11004: 'icondingdanlie-feiji', //icon_tk,
        11005: 'icondingdanlie-feiji', //icon_tk,
        11006: 'icondingdanlie-feiji', //icon_tk,
        11007: 'icondingdanlie-jiudian', //icon_ht,
        11008: 'icondingdanlie-jiudian', //icon_ht,
        11009: 'icondingdanlie-huoche', //icon_tr,
        11010: 'icondingdanlie-huoche', //icon_tr,
        11011: 'icondingdanlie-huoche', //icon_tr,
        11018: 'icondingdanlie-yongche', //icon_car,
        11023: 'icondingdanlie-qianzheng', //icon_visa,
        11028: 'icondingdanlie-xiuxishi',
        11029: 'icondingdanlie-kuaisuanjian',
        11030: 'icondingdanlie-youxianzhiji',
        11031: 'icondingdanlie-yaoketong',
      }
      return obj[val] || ''
    },
    color (val) {
      let obj = {
        11001: '#dbab56', //icon_tk,
        11002: '#dbab56', //icon_tk,
        11003: '#dbab56', //icon_tk,
        11004: '#dbab56', //icon_tk,
        11005: '#dbab56', //icon_tk,
        11006: '#dbab56', //icon_tk,
        11007: '#ffb757', //icon_ht,
        11008: '#ffb757', //icon_ht,
        11009: '#6452ef', //icon_tr,
        11010: '#6452ef', //icon_tr,
        11011: '#6452ef', //icon_tr,
        11018: '#51a5f2', //icon_car,
        11023: '#ed7f4f', //icon_visa,
        11028: '#f7bc33',
        11029: '#a1d656',
        11030: '#3ed9e5',
        11031: '#4e95ea',
      }
      return obj[val] || ''
    },
    //机票：1普通 2官网 3协议
    //酒店：1现付担保
    //用车：1日包 2半日包 3点到点 4接机 5送机 6接站 7送站  8即时快车 9预约快车 10及时专车 11预约专车 12及时出租车 13预约出租车
    carproductType (type) {
      var obj = {
        0: '',
        1: '日包',
        2: '半日包',
        3: '3点到点',
        4: '接机',
        5: '送机',
        6: '接站',
        7: '送站',
        8: '即时快车',
        9: '预约快车',
        10: '及时专车',
        11: '预约专车',
        12: '及时出租车',
        13: '预约出租车',
      }
      return obj[type] || ''
    },
    setOutModel (type) {
      var obj = {
        0: '国内出发/国际出发',
        1: '国内出发',
        2: '国内到达',
        3: '国际出发',
        4: '国际到达',
      }
      return obj[type] || ''
    },
    orderType (type) {
      var obj = {
        11028: '休息室',
        11029: '快速安检',
        11030: '优先值机',
        11031: '要客通',
      }
      return obj[type] || ''
    },
  },
}
</script>

<style lang="less" scoped>
.mescroll {
  height: calc(100vh - 50px);
}
.bg-white {
  background: #fff;
}
.iconTheme {
  background: #fff;
  //margin: 0px 20px 0px 20px;
  padding: 20px 0px 10px 0px;
  border-radius: 10px;
  position: relative;
  top: -78px;
  //box-shadow: 3px 3px 5px #f3f3f3;

}
.contain {
  margin-top: -74px;
}
.logotext {
  margin-top: 20px;
}
</style>
